import { configureStore } from '@reduxjs/toolkit';
import computer from '../features/battle/computerSlice';
import player from '../features/battle/playerSlice';

export const store = configureStore({
	reducer: {
		computer,
		player
	},
	middleware: getDefaultMiddleware => getDefaultMiddleware(),
	devTools: process.env.NODE_ENV !== 'production'
});